import { Action } from '@ngrx/store';
import { Session } from '../../types/session.types';

export enum SessionActionTypes {
  Load = '[Session] Load session',
  ReLoad = '[Session] Reload session',
  LoadSuccess = '[Session] Load session success',
  LoadFailed = '[Session] Load session failed'
}

export class LoadSession implements Action {
  public readonly type: string = SessionActionTypes.Load;
  public readonly payload = undefined;
}

export class ReLoadSession implements Action {
  public readonly type: string = SessionActionTypes.ReLoad;
  public readonly payload = undefined;
}

export class LoadSessionSuccess implements Action {
  public readonly type: string = SessionActionTypes.LoadSuccess;
  constructor(public payload: Session.SessionModel) {}
}

export class LoadSessionFailed implements Action {
  public readonly type: string = SessionActionTypes.LoadFailed;
  constructor(public payload: string) {}
}

export type SessionActionUnion =
  | LoadSession
  | ReLoadSession
  | LoadSessionSuccess
  | LoadSessionFailed;
